import * as Sentry from "@sentry/react";

export default class DebugLogger {
  constructor(moduleName) {
    this.moduleName = moduleName;
  }

  log(msg) {
    if (import.meta.env.VITE_LOG_LEVEL === "debug") {
      Sentry.captureMessage(`${this.moduleName} ${msg}`);
    }
  }
}
